import React from "react";
import InputMask from "react-input-mask";

function PidFormControl(props) {

    return (
        <InputMask mask='999-999-999' {...props} />
    )
}

export default PidFormControl;
